import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';
import { StripeProvider } from 'react-stripe-elements';

import TitleWithShape from 'components/TitleWithShape';

import StripeCheckout from './Stripe/StripeCheckoutWrapper';

const Wrapper = styled.div`
  color: #35447d;
  padding-left: 5.4rem;
  padding-right: 5.4rem;
  padding-top: 6.8rem;

  .page-title {
    padding-left: 11rem;
  }
  .form-wrapper {
    display: flex;
    margin-top: 9rem;
    justify-content: center;

    .left-pane {
      background: #F8F7F3;
      width: 66rem;
      position: relative;
      padding: 8rem;
      .content {
        margin-top: 2rem;
        .expiry {
          display: flex;
          justify-content: space-between;
        }
      }
    }
    .right-pane {
      display: flex;
      margin-left: 12rem;

      .detail {
        height: 14rem;
        width: 45rem;
        display: flex;
        align-items: center;
        padding: 3rem 3rem;
        background: #e1e1e1;
        justify-content: space-between;
        p {
          font-size: 2.8rem;
          padding: 0;
          margin: 0;
        }
        h1 {
          padding: 0;
          margin: 0;
          font-size: 4.5rem;
        }
        h4 {
          padding: 0;
          margin: 0;
          font-size: 1.8rem;
        }
      }
    }
    .button-wrapper {
      display: flex;
      justify-content: flex-end;
      margin-top: 5rem;
    }
  }

  @media only screen and (max-width: 1100px) {
    padding-left: 0;
    padding-right: 0;
    margin: auto;
    .form-wrapper {
      flex-direction: column-reverse;
      margin-left: auto;
      margin-right: auto;
      align-items: center;
      .left-pane {
        margin-top: 5rem;
      }
      .right-pane {
        justify-content: center;
        margin-left: 0;
      }
    }
  }

  @media (max-width: 600px) {
    .form-wrapper {
      .left-pane {
        width: 100%;
      }
    }
  }
`;

class Step9 extends Component {
  constructor(props) {
    super(props);
    this.state = { redirect: false };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onSuccess = (token) => {
    fetch(`${process.env.REACT_APP_API_ENDPOINT}/charge`, {
      method: 'POST',
      body: JSON.stringify({
        email: this.props.email,
        token: token.id,
      }),
    }).then((res) => {
      if (res.ok) {
        return res.json();
      }
      // @TODO: Error handling here...
      return null;
    }).then((json) => {
      if (json.data.id) {
        this.setState({
          receiptNumber: json.data.id
        }, () => this.nextFormPage());
      }
    });
  }

  nextFormPage() {
    this.setState({ completed: true }, () => {
      this.props.collectData('step9', this.state);
      this.setState({ redirect: '/get-started/step-ten' });
    });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} push />;
    }

    return (
      <Wrapper>
        <div className="page-title">
          <TitleWithShape title="Confirm payment now to get quick legal advice" />
        </div>
        <div className="form-wrapper">
          <div className="left-pane">
            <TitleWithShape title="Payment details" />
            <div className="content">
              <StripeProvider apiKey={process.env.REACT_APP_STRIPE_PUBLIC_KEY}>
                <StripeCheckout onSuccess={this.onSuccess} name={this.props.name} />
              </StripeProvider>
            </div>
          </div>
          <div className="right-pane">
            <div className="detail">
              <p>Total due today</p>
              <div>
                <h1>$880</h1>
                <h4>incl.GST</h4>
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

Step9.propTypes = {
  collectData: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default Step9;



// WEBPACK FOOTER //
// ./src/containers/BeginPage/Step9.js